import { render, staticRenderFns } from "./SideToolbarLayout.vue?vue&type=template&id=a97e75c8"
import script from "./SideToolbarLayout.vue?vue&type=script&lang=js"
export * from "./SideToolbarLayout.vue?vue&type=script&lang=js"
import style0 from "./SideToolbarLayout.vue?vue&type=style&index=0&id=a97e75c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports